import { atom } from 'recoil';
import { UserTourSummary } from '@app/shared/models/user-tours.type';

export const atom_myToursState = atom<UserTourSummary[]>({
	key: 'MyTours',
	default: [],
});

export const atom_myToursLoadingState = atom<'idle' | 'loading' | 'success' | 'error'>({
	key: 'MyToursLoading',
	default: 'idle',
});

export const atom_myToursError = atom<string | null>({
	key: 'MyToursError',
	default: null,
});
